import React, { useState } from 'react';

interface PointProps {
  cx: number,
  value: number,
  stroke: string,
  limit: number,
  paddingVertical: number,
  chartHeight: number,
  onClick?: () => void,
}

const Point = ({
  cx, value, stroke, limit, paddingVertical, chartHeight, onClick,
}: PointProps) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const [pressed, setPressed] = useState<boolean>(false);
  return !!value
    && <circle
      r={hovered ? 5 : 3}
      strokeWidth={hovered ? 10 : 6}
      opacity={pressed ? 0.5 : 1}
      {...{ stroke, cx, onClick }}
      cy={paddingVertical + (chartHeight - 1 - paddingVertical * 2) * (1 - value / limit)}
      fill={stroke}
      strokeOpacity={0.3}
      onMouseEnter={onClick ? () => setHovered(true) : null}
      onMouseLeave={onClick ? () => setHovered(false) : null}
      onMouseDown={onClick ? () => setPressed(true) : null}
      onMouseUp={onClick ? () => setPressed(false) : null}
    />;
};

export default Point;
